import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=77b02769&scoped=true"
import script from "./roleEdit?vue&type=script&lang=js&external"
export * from "./roleEdit?vue&type=script&lang=js&external"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=77b02769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b02769",
  null
  
)

export default component.exports